import{useLayoutEffect}from'react';var index=useLayoutEffect;export default index;